export const EntityType = {
  USER_VEHICLE: "user_vehicle",
};

export const QueryKeys = {
  userVehicle: () => [EntityType.USER_VEHICLE, "LIST"],
};
